var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStocks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.747,
    height: 22.245,
    viewBox: "0 0 19.747 22.245",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M380.407,321.324l-6.261-3.371a25.66,25.66,0,0,0-2.731-1.471c-.706-.274-1.257.2-1.879.539l-7.318,3.94c-.636.343-1.014.551-1.042,1.33-.041,1.131,0,2.271,0,3.4v4.6a17.631,17.631,0,0,0,0,2.8c.126.747.991.992,1.6,1.319l3.844,2.07,3.534,1.9a1.466,1.466,0,0,0,1.648,0l7.377-3.973c.694-.373,1.5-.586,1.6-1.438a31,31,0,0,0,0-3.594v-5.11C380.776,323.663,381.113,321.7,380.407,321.324Zm-10.131,15.545-5.984-3.222c-.4-.217-1.47-.541-1.7-.918-.1-.167-.011-.679-.011-.872v-8.744l6.284,3.383c.338.182,1.225.469,1.4.754.107.174.017.671.017.874v8.745Zm.7-10.823q-3.812-2.053-7.624-4.106l6.886-3.707c.189-.1.546-.393.759-.386a5.639,5.639,0,0,1,1.361.733l2.918,1.571,3.323,1.789Zm8.4,6.677-7.7,4.146v-8a5.312,5.312,0,0,1,0-1.458c.084-.234.067-.144.312-.324A32.9,32.9,0,0,1,375.875,325l3.5-1.885Z",
    transform: "translate(-361.11 -316.401)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStocks);
export default __webpack_public_path__ + "static/media/stocks.4143cbe10913756ffb4039ca4c4423e3.svg";
export { ForwardRef as ReactComponent };